<template>
  <!--begin::Main-->

  <!--begin::Drawers-->
  <!--begin::Activities drawer-->

  <!--begin::Content-->
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div
          data-kt-swapper="true"
          data-kt-swapper-mode="prepend"
          data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
          class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
        >
          <!--begin::Title-->
          <h1 class="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
            {{ $t("dashboard") }}
            <!--begin::Separator-->
            <span class="h-20px border-gray-200 border-start ms-3 mx-2"></span>
            <!--end::Separator-->
            <!--begin::Description-->
            <!--            <small class="text-muted fs-7 fw-bold my-1 ms-1">#XRS-45670</small>-->
            <!--end::Description-->
          </h1>
          <!--end::Title-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!--begin::Filter menu-->
          <div class="m-0">
            <!--begin::Menu toggle-->
            <!--            <a href="#" class="btn btn-sm btn-flex btn-light btn-active-primary fw-bolder" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">-->
            <!--              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen031.svg&ndash;&gt;-->
            <!--              <span class="svg-icon svg-icon-5 svg-icon-gray-500 me-1">-->
            <!--											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
            <!--												<path d="M19.0759 3H4.72777C3.95892 3 3.47768 3.83148 3.86067 4.49814L8.56967 12.6949C9.17923 13.7559 9.5 14.9582 9.5 16.1819V19.5072C9.5 20.2189 10.2223 20.7028 10.8805 20.432L13.8805 19.1977C14.2553 19.0435 14.5 18.6783 14.5 18.273V13.8372C14.5 12.8089 14.8171 11.8056 15.408 10.964L19.8943 4.57465C20.3596 3.912 19.8856 3 19.0759 3Z" fill="black" />-->
            <!--											</svg>-->
            <!--										</span>-->
            <!--              &lt;!&ndash;end::Svg Icon&ndash;&gt;Filter</a>-->
            <!--end::Menu toggle-->
            <!--begin::Menu 1-->
            <div
              class="menu menu-sub menu-sub-dropdown w-250px w-md-300px"
              data-kt-menu="true"
              id="kt_menu_6205ad357830a"
            >
              <!--begin::Header-->
              <div class="px-7 py-5">
                <div class="fs-5 text-dark fw-bolder">Filter Options</div>
              </div>
              <!--end::Header-->
              <!--begin::Menu separator-->
              <div class="separator border-gray-200"></div>
              <!--end::Menu separator-->
              <!--begin::Form-->
              <div class="px-7 py-5">
                <!--begin::Input group-->
                <div class="mb-10">
                  <!--begin::Label-->
                  <label class="form-label fw-bold">Status:</label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <div>
                    <select
                      class="form-select form-select-solid"
                      data-kt-select2="true"
                      data-placeholder="Select option"
                      data-dropdown-parent="#kt_menu_6205ad357830a"
                      data-allow-clear="true"
                    >
                      <option></option>
                      <option value="1">Approved</option>
                      <option value="2">Pending</option>
                      <option value="2">In Process</option>
                      <option value="2">Rejected</option>
                    </select>
                  </div>
                  <!--end::Input-->
                </div>
                <!--end::Input group-->
                <!--begin::Input group-->
                <div class="mb-10">
                  <!--begin::Label-->
                  <label class="form-label fw-bold">Member Type:</label>
                  <!--end::Label-->
                  <!--begin::Options-->
                  <div class="d-flex">
                    <!--begin::Options-->
                    <label
                      class="form-check form-check-sm form-check-custom form-check-solid me-5"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="1"
                      />
                      <span class="form-check-label">Author</span>
                    </label>
                    <!--end::Options-->
                    <!--begin::Options-->
                    <label
                      class="form-check form-check-sm form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value="2"
                        checked="checked"
                      />
                      <span class="form-check-label">Customer</span>
                    </label>
                    <!--end::Options-->
                  </div>
                  <!--end::Options-->
                </div>
                <!--end::Input group-->
                <!--begin::Input group-->
                <div class="mb-10">
                  <!--begin::Label-->
                  <label class="form-label fw-bold">Notifications:</label>
                  <!--end::Label-->
                  <!--begin::Switch-->
                  <div
                    class="form-check form-switch form-switch-sm form-check-custom form-check-solid"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      name="notifications"
                      checked="checked"
                    />
                    <label class="form-check-label">Enabled</label>
                  </div>
                  <!--end::Switch-->
                </div>
                <!--end::Input group-->
                <!--begin::Actions-->
                <div class="d-flex justify-content-end">
                  <button
                    type="reset"
                    class="btn btn-sm btn-light btn-active-light-primary me-2"
                    data-kt-menu-dismiss="true"
                  >
                    Reset
                  </button>
                  <button
                    type="submit"
                    class="btn btn-sm btn-primary"
                    data-kt-menu-dismiss="true"
                  >
                    Apply
                  </button>
                </div>
                <!--end::Actions-->
              </div>
              <!--end::Form-->
            </div>
            <!--end::Menu 1-->
          </div>
          <!--end::Filter menu-->
          <!--begin::Secondary button-->
          <!--end::Secondary button-->
          <!--begin::Primary button-->
          <!--          <a href="../../demo1/dist/.html" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_create_app">Create</a>-->
          <!--end::Primary button-->
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::Toolbar-->
    <!--begin::Post-->
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <!--begin::Container-->
      <div id="kt_content_container" class="container-xxl">
        <!--begin::Row-->
        <div class="row gy-5 g-xl-8">
          <!--begin::Col-->
          <div class="col-xl-4">
            <!--begin::Mixed Widget 2-->
            <div class="card card-xl-stretch">
              <!--begin::Header-->
              <div class="card-header border-0 bg-danger py-5">
                <h3 class="card-title fw-bolder text-white">
                  {{ $t("order") }}
                </h3>
                <div class="card-toolbar">
                  <!--begin::Menu-->
                  <button
                    type="button"
                    class="btn btn-sm btn-icon btn-color-white btn-active-white btn-active-color- border-0 me-n3"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                  >
                    <!--begin::Svg Icon | path: icons/duotune/general/gen024.svg-->
                    <span class="svg-icon svg-icon-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect
                            x="5"
                            y="5"
                            width="5"
                            height="5"
                            rx="1"
                            fill="#000000"
                          />
                          <rect
                            x="14"
                            y="5"
                            width="5"
                            height="5"
                            rx="1"
                            fill="#000000"
                            opacity="0.3"
                          />
                          <rect
                            x="5"
                            y="14"
                            width="5"
                            height="5"
                            rx="1"
                            fill="#000000"
                            opacity="0.3"
                          />
                          <rect
                            x="14"
                            y="14"
                            width="5"
                            height="5"
                            rx="1"
                            fill="#000000"
                            opacity="0.3"
                          />
                        </g>
                      </svg>
                    </span>
                    <!--end::Svg Icon-->
                  </button>
                  <!--begin::Menu 3-->
                  <div
                    class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3"
                    data-kt-menu="true"
                  >
                    <!--begin::Heading-->
                    <div class="menu-item px-3">
                      <div
                        class="menu-content text-muted pb-2 px-3 fs-7 text-uppercase"
                      >
                        Payments
                      </div>
                    </div>
                    <!--end::Heading-->
                    <!--begin::Menu item-->
                    <div class="menu-item px-3">
                      <a href="#" class="menu-link px-3">Create Invoice</a>
                    </div>
                    <!--end::Menu item-->
                    <!--begin::Menu item-->
                    <div class="menu-item px-3">
                      <a href="#" class="menu-link flex-stack px-3"
                        >Create Payment
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          title="Specify a target name for future usage and reference"
                        ></i
                      ></a>
                    </div>
                    <!--end::Menu item-->
                    <!--begin::Menu item-->
                    <div class="menu-item px-3">
                      <a href="#" class="menu-link px-3">Generate Bill</a>
                    </div>
                    <!--end::Menu item-->
                    <!--begin::Menu item-->
                    <div
                      class="menu-item px-3"
                      data-kt-menu-trigger="hover"
                      data-kt-menu-placement="right-end"
                    >
                      <a href="#" class="menu-link px-3">
                        <span class="menu-title">Subscription</span>
                        <span class="menu-arrow"></span>
                      </a>
                      <!--begin::Menu sub-->
                      <div class="menu-sub menu-sub-dropdown w-175px py-4">
                        <!--begin::Menu item-->
                        <div class="menu-item px-3">
                          <a href="#" class="menu-link px-3">Plans</a>
                        </div>
                        <!--end::Menu item-->
                        <!--begin::Menu item-->
                        <div class="menu-item px-3">
                          <a href="#" class="menu-link px-3">Billing</a>
                        </div>
                        <!--end::Menu item-->
                        <!--begin::Menu item-->
                        <div class="menu-item px-3">
                          <a href="#" class="menu-link px-3">Statements</a>
                        </div>
                        <!--end::Menu item-->
                        <!--begin::Menu separator-->
                        <div class="separator my-2"></div>
                        <!--end::Menu separator-->
                        <!--begin::Menu item-->
                        <div class="menu-item px-3">
                          <div class="menu-content px-3">
                            <!--begin::Switch-->
                            <label
                              class="form-check form-switch form-check-custom form-check-solid"
                            >
                              <!--begin::Input-->
                              <input
                                class="form-check-input w-30px h-20px"
                                type="checkbox"
                                value="1"
                                checked="checked"
                                name="notifications"
                              />
                              <!--end::Input-->
                              <!--end::Label-->
                              <span class="form-check-label text-muted fs-6"
                                >Recuring</span
                              >
                              <!--end::Label-->
                            </label>
                            <!--end::Switch-->
                          </div>
                        </div>
                        <!--end::Menu item-->
                      </div>
                      <!--end::Menu sub-->
                    </div>
                    <!--end::Menu item-->
                    <!--begin::Menu item-->
                    <div class="menu-item px-3 my-1">
                      <a href="#" class="menu-link px-3">Settings</a>
                    </div>
                    <!--end::Menu item-->
                  </div>
                  <!--end::Menu 3-->
                  <!--end::Menu-->
                </div>
              </div>
              <!--end::Header-->
              <!--begin::Body-->
              <div class="card-body p-0">
                <!--begin::Chart-->
                <div
                  class="mixed-widget-2-chart card-rounded-bottom bg-danger"
                  data-kt-color="danger"
                  style="height: 200px"
                ></div>
                <!--end::Chart-->
                <!--begin::Stats-->
                <div class="card-p mt-n20 position-relative">
                  <!--begin::Row-->
                  <div class="row g-0">
                    <!--begin::Col-->
                    <div
                      class="col bg-light-warning px-6 py-8 rounded-2 me-7 mb-7"
                    >
                      <!--begin::Svg Icon | path: icons/duotune/general/gen032.svg-->
                      <span
                        class="svg-icon svg-icon-3x svg-icon-warning d-block my-2"
                      >
                        {{ form.newOrdersCount }}
                      </span>
                      <!--end::Svg Icon-->
                      <router-link
                        :to="{ name: 'Order' }"
                        class="text-warning fw-bold fs-6"
                        >{{ $t("new") }}</router-link
                      >
                    </div>
                    <!--end::Col-->
                    <!--begin::Col-->
                    <div class="col bg-light-primary px-6 py-8 rounded-2 mb-7">
                      <!--begin::Svg Icon | path: icons/duotune/finance/fin006.svg-->
                      <span
                        class="svg-icon svg-icon-3x svg-icon-primary d-block my-2"
                      >
                        {{ form.waitingOrdersCount }}
                      </span>
                      <!--end::Svg Icon-->
                      <router-link
                        :to="{ name: 'OrderWaitingPayment' }"
                        class="text-primary fw-bold fs-6"
                        >{{ $t("waitingPayment") }}</router-link
                      >
                    </div>
                    <!--end::Col-->
                  </div>

                  <div class="row g-0">
                    <!--begin::Col-->
                    <div
                      class="col bg-light-info px-6 py-8 rounded-2 me-7 mb-7"
                    >
                      <!--begin::Svg Icon | path: icons/duotune/general/gen032.svg-->
                      <span
                        class="svg-icon svg-icon-3x svg-icon-warning d-block my-2"
                      >
                        {{ form.cutCaseOrdersCount }}
                      </span>
                      <!--end::Svg Icon-->
                      <router-link
                        :to="{ name: 'OrderCutCase' }"
                        class="text-warning fw-bold fs-6"
                        >{{ $t("cutCase") }}</router-link
                      >
                    </div>
                    <!--end::Col-->
                    <!--begin::Col-->
                    <div class="col bg-light-primary px-6 py-8 rounded-2 mb-7">
                      <!--begin::Svg Icon | path: icons/duotune/finance/fin006.svg-->
                      <span
                        class="svg-icon svg-icon-3x svg-icon-primary d-block my-2"
                      >
                        {{ form.sewingCaseOrdersCount }}
                      </span>
                      <!--end::Svg Icon-->
                      <router-link
                        :to="{ name: 'OrderSewingCase' }"
                        class="text-primary fw-bold fs-6"
                        >{{ $t("sewingCase") }}</router-link
                      >
                    </div>
                    <!--end::Col-->
                  </div>
                  <!--end::Row-->
                  <!--begin::Row-->

                  <div class="row g-0">
                    <!--begin::Col-->
                    <div class="col bg-light-danger px-6 py-8 rounded-2 me-7">
                      <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                      <span
                        class="svg-icon svg-icon-3x svg-icon-danger d-block my-2"
                      >
                        {{ form.buttonCaseOrdersCount }}
                      </span>

                      <!--end::Svg Icon-->
                      <router-link
                        :to="{ name: 'OrderButtonCase' }"
                        class="text-danger fw-bold fs-6 mt-2"
                        >{{ $t("buttonCase") }}</router-link
                      >
                    </div>
                    <!--end::Col-->
                    <!--begin::Col-->
                    <div class="col bg-light-success px-6 py-8 rounded-2">
                      <!--begin::Svg Icon | path: icons/duotune/communication/com010.svg-->
                      <span
                        class="svg-icon svg-icon-3x svg-icon-danger d-block my-2"
                      >
                        {{ form.readyToDeliverOrdersCount }}
                      </span>

                      <!--end::Svg Icon-->
                      <router-link
                        :to="{ name: 'OrderReadyToDeliver' }"
                        class="text-success fw-bold fs-6 mt-2"
                        >{{ $t("ready_to_deliver") }}</router-link
                      >
                    </div>
                    <!--end::Col-->
                  </div>

                  <div class="row g-0">
                    <!--begin::Col-->
                    <div class="col bg-light-success px-6 py-8 rounded-2">
                      <!--begin::Svg Icon | path: icons/duotune/communication/com010.svg-->
                      <span
                        class="svg-icon svg-icon-3x svg-icon-danger d-block my-2"
                      >
                        {{ form.deliveredOrdersCount }}
                      </span>

                      <!--end::Svg Icon-->
                      <router-link
                        :to="{ name: 'OrderDelivered' }"
                        class="text-success fw-bold fs-6 mt-2"
                        >{{ $t("delivered") }}</router-link
                      >
                    </div>
                    <!--end::Col-->
                  </div>

                  <!--end::Row-->
                </div>
                <!--end::Stats-->
              </div>
              <!--end::Body-->
            </div>
            <!--end::Mixed Widget 2-->
          </div>
          <div class="col-xl-8">
            <!--begin::Tables Widget 9-->
            <div class="card-body p-0">
              <!--begin::Chart-->
              <div
                class="mixed-widget-2-chart card-rounded-bottom bg-danger"
                data-kt-color="danger"
                style="height: 200px"
              ></div>
              <!--end::Chart-->
              <!--begin::Stats-->
              <div class="card-p mt-n20 position-relative">
                <!--begin::Row-->
                <div class="row g-0">
                  <!--begin::Col-->
                  <div
                    class="col bg-light-warning px-6 py-8 rounded-2 me-7 mb-7"
                  >
                    <!--begin::Svg Icon | path: icons/duotune/general/gen032.svg-->
                    <span
                      class="svg-icon svg-icon-3x svg-icon-warning d-block my-2"
                    >
                      {{ form.dailyOrdersCount }}
                    </span>
                    <!--end::Svg Icon-->
                    <a href="#" class="text-warning fw-bold fs-6">{{
                      $t("daily")
                    }}</a>
                  </div>
                  <!--end::Col-->
                  <!--begin::Col-->
                  <div class="col bg-light-primary px-6 py-8 rounded-2 mb-7">
                    <!--begin::Svg Icon | path: icons/duotune/finance/fin006.svg-->
                    <span
                      class="svg-icon svg-icon-3x svg-icon-primary d-block my-2"
                    >
                      {{ form.usersCount }}
                    </span>
                    <!--end::Svg Icon-->
                    <router-link
                      :to="{ name: 'User' }"
                      class="text-primary fw-bold fs-6"
                      >{{ $t("users") }}</router-link
                    >
                  </div>
                  <!--end::Col-->
                </div>

                <div class="row g-0">
                  <!--begin::Col-->
                  <div class="col bg-light-info px-6 py-8 rounded-2 me-7 mb-7">
                    <!--begin::Svg Icon | path: icons/duotune/general/gen032.svg-->
                    <span
                      class="svg-icon svg-icon-3x svg-icon-warning d-block my-2"
                    >
                      {{ form.weeklyOrdersCount }}
                    </span>
                    <!--end::Svg Icon-->
                    <a href="#" class="text-warning fw-bold fs-6">{{
                      $t("weekly")
                    }}</a>
                  </div>
                  <!--end::Col-->
                  <!--begin::Col-->
                  <div class="col bg-light-primary px-6 py-8 rounded-2 mb-7">
                    <!--begin::Svg Icon | path: icons/duotune/finance/fin006.svg-->
                    <span
                      class="svg-icon svg-icon-3x svg-icon-primary d-block my-2"
                    >
                      {{ form.employeeCount }}
                    </span>
                    <!--end::Svg Icon-->
                    <router-link
                      :to="{ name: 'Admin' }"
                      class="text-primary fw-bold fs-6"
                      >{{ $t("employeeCount") }}</router-link
                    >
                  </div>
                  <!--end::Col-->
                </div>
                <!--end::Row-->
                <!--begin::Row-->

                <div class="row g-0">
                  <!--begin::Col-->
                  <div class="col bg-light-danger px-6 py-8 rounded-2 me-7">
                    <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                    <span
                      class="svg-icon svg-icon-3x svg-icon-danger d-block my-2"
                    >
                      {{ form.monthlyOrdersCount }}
                    </span>

                    <!--end::Svg Icon-->
                    <a href="#" class="text-danger fw-bold fs-6 mt-2">{{
                      $t("monthly")
                    }}</a>
                  </div>
                  <!--end::Col-->
                  <!--begin::Col-->
                  <div class="col bg-light-success px-6 py-8 rounded-2">
                    <!--begin::Svg Icon | path: icons/duotune/communication/com010.svg-->
                    <span
                      class="svg-icon svg-icon-3x svg-icon-danger d-block my-2"
                    >
                      {{ form.adminsCount }}
                    </span>

                    <!--end::Svg Icon-->
                    <router-link
                      :to="{ name: 'Admin' }"
                      class="text-success fw-bold fs-6 mt-2"
                      >{{ $t("adminsCount") }}</router-link
                    >
                  </div>
                  <!--end::Col-->
                </div>

                <!--end::Row-->
              </div>
              <!--end::Stats-->
            </div>
            <!--end::Tables Widget 9-->
          </div>

          <!--end::Col-->
          <!--begin::Col-->
          <!--          <div class="col-xl-4">-->
          <!--            &lt;!&ndash;begin::List Widget 5&ndash;&gt;-->
          <!--            <div class="card card-xl-stretch">-->
          <!--              &lt;!&ndash;begin::Header&ndash;&gt;-->
          <!--              <div class="card-header align-items-center border-0 mt-4">-->
          <!--                <h3 class="card-title align-items-start flex-column">-->
          <!--                  <span class="fw-bolder mb-2 text-dark">Activities</span>-->
          <!--                  <span class="text-muted fw-bold fs-7">890,344 Sales</span>-->
          <!--                </h3>-->
          <!--                <div class="card-toolbar">-->
          <!--                  &lt;!&ndash;begin::Menu&ndash;&gt;-->
          <!--                  <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">-->
          <!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen024.svg&ndash;&gt;-->
          <!--                    <span class="svg-icon svg-icon-2">-->
          <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">-->
          <!--																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
          <!--																	<rect x="5" y="5" width="5" height="5" rx="1" fill="#000000" />-->
          <!--																	<rect x="14" y="5" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
          <!--																	<rect x="5" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
          <!--																	<rect x="14" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
          <!--																</g>-->
          <!--															</svg>-->
          <!--														</span>-->
          <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
          <!--                  </button>-->
          <!--                  &lt;!&ndash;begin::Menu 1&ndash;&gt;-->
          <!--                  <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true" id="kt_menu_6205ad35855bb">-->
          <!--                    &lt;!&ndash;begin::Header&ndash;&gt;-->
          <!--                    <div class="px-7 py-5">-->
          <!--                      <div class="fs-5 text-dark fw-bolder">Filter Options</div>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Header&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Menu separator&ndash;&gt;-->
          <!--                    <div class="separator border-gray-200"></div>-->
          <!--                    &lt;!&ndash;end::Menu separator&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Form&ndash;&gt;-->
          <!--                    <div class="px-7 py-5">-->
          <!--                      &lt;!&ndash;begin::Input group&ndash;&gt;-->
          <!--                      <div class="mb-10">-->
          <!--                        &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                        <label class="form-label fw-bold">Status:</label>-->
          <!--                        &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                        &lt;!&ndash;begin::Input&ndash;&gt;-->
          <!--                        <div>-->
          <!--                          <select class="form-select form-select-solid" data-kt-select2="true" data-placeholder="Select option" data-dropdown-parent="#kt_menu_6205ad35855bb" data-allow-clear="true">-->
          <!--                            <option></option>-->
          <!--                            <option value="1">Approved</option>-->
          <!--                            <option value="2">Pending</option>-->
          <!--                            <option value="2">In Process</option>-->
          <!--                            <option value="2">Rejected</option>-->
          <!--                          </select>-->
          <!--                        </div>-->
          <!--                        &lt;!&ndash;end::Input&ndash;&gt;-->
          <!--                      </div>-->
          <!--                      &lt;!&ndash;end::Input group&ndash;&gt;-->
          <!--                      &lt;!&ndash;begin::Input group&ndash;&gt;-->
          <!--                      <div class="mb-10">-->
          <!--                        &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                        <label class="form-label fw-bold">Member Type:</label>-->
          <!--                        &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                        &lt;!&ndash;begin::Options&ndash;&gt;-->
          <!--                        <div class="d-flex">-->
          <!--                          &lt;!&ndash;begin::Options&ndash;&gt;-->
          <!--                          <label class="form-check form-check-sm form-check-custom form-check-solid me-5">-->
          <!--                            <input class="form-check-input" type="checkbox" value="1" />-->
          <!--                            <span class="form-check-label">Author</span>-->
          <!--                          </label>-->
          <!--                          &lt;!&ndash;end::Options&ndash;&gt;-->
          <!--                          &lt;!&ndash;begin::Options&ndash;&gt;-->
          <!--                          <label class="form-check form-check-sm form-check-custom form-check-solid">-->
          <!--                            <input class="form-check-input" type="checkbox" value="2" checked="checked" />-->
          <!--                            <span class="form-check-label">Customer</span>-->
          <!--                          </label>-->
          <!--                          &lt;!&ndash;end::Options&ndash;&gt;-->
          <!--                        </div>-->
          <!--                        &lt;!&ndash;end::Options&ndash;&gt;-->
          <!--                      </div>-->
          <!--                      &lt;!&ndash;end::Input group&ndash;&gt;-->
          <!--                      &lt;!&ndash;begin::Input group&ndash;&gt;-->
          <!--                      <div class="mb-10">-->
          <!--                        &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                        <label class="form-label fw-bold">Notifications:</label>-->
          <!--                        &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                        &lt;!&ndash;begin::Switch&ndash;&gt;-->
          <!--                        <div class="form-check form-switch form-switch-sm form-check-custom form-check-solid">-->
          <!--                          <input class="form-check-input" type="checkbox" value="" name="notifications" checked="checked" />-->
          <!--                          <label class="form-check-label">Enabled</label>-->
          <!--                        </div>-->
          <!--                        &lt;!&ndash;end::Switch&ndash;&gt;-->
          <!--                      </div>-->
          <!--                      &lt;!&ndash;end::Input group&ndash;&gt;-->
          <!--                      &lt;!&ndash;begin::Actions&ndash;&gt;-->
          <!--                      <div class="d-flex justify-content-end">-->
          <!--                        <button type="reset" class="btn btn-sm btn-light btn-active-light-primary me-2" data-kt-menu-dismiss="true">Reset</button>-->
          <!--                        <button type="submit" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true">Apply</button>-->
          <!--                      </div>-->
          <!--                      &lt;!&ndash;end::Actions&ndash;&gt;-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Form&ndash;&gt;-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;end::Menu 1&ndash;&gt;-->
          <!--                  &lt;!&ndash;end::Menu&ndash;&gt;-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              &lt;!&ndash;end::Header&ndash;&gt;-->
          <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
          <!--              <div class="card-body pt-5">-->
          <!--                &lt;!&ndash;begin::Timeline&ndash;&gt;-->
          <!--                <div class="timeline-label">-->
          <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
          <!--                  <div class="timeline-item">-->
          <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                    <div class="timeline-label fw-bolder text-gray-800 fs-6">08:42</div>-->
          <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Badge&ndash;&gt;-->
          <!--                    <div class="timeline-badge">-->
          <!--                      <i class="fa fa-genderless text-warning fs-1"></i>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Badge&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Text&ndash;&gt;-->
          <!--                    <div class="fw-mormal timeline-content text-muted ps-3">Outlines keep you honest. And keep structure</div>-->
          <!--                    &lt;!&ndash;end::Text&ndash;&gt;-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
          <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
          <!--                  <div class="timeline-item">-->
          <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                    <div class="timeline-label fw-bolder text-gray-800 fs-6">10:00</div>-->
          <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Badge&ndash;&gt;-->
          <!--                    <div class="timeline-badge">-->
          <!--                      <i class="fa fa-genderless text-success fs-1"></i>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Badge&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Content&ndash;&gt;-->
          <!--                    <div class="timeline-content d-flex">-->
          <!--                      <span class="fw-bolder text-gray-800 ps-3">AEOL meeting</span>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Content&ndash;&gt;-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
          <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
          <!--                  <div class="timeline-item">-->
          <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                    <div class="timeline-label fw-bolder text-gray-800 fs-6">14:37</div>-->
          <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Badge&ndash;&gt;-->
          <!--                    <div class="timeline-badge">-->
          <!--                      <i class="fa fa-genderless text-danger fs-1"></i>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Badge&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Desc&ndash;&gt;-->
          <!--                    <div class="timeline-content fw-bolder text-gray-800 ps-3">Make deposit-->
          <!--                      <a href="#" class="text-primary">USD 700</a>. to ESL</div>-->
          <!--                    &lt;!&ndash;end::Desc&ndash;&gt;-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
          <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
          <!--                  <div class="timeline-item">-->
          <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                    <div class="timeline-label fw-bolder text-gray-800 fs-6">16:50</div>-->
          <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Badge&ndash;&gt;-->
          <!--                    <div class="timeline-badge">-->
          <!--                      <i class="fa fa-genderless text-primary fs-1"></i>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Badge&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Text&ndash;&gt;-->
          <!--                    <div class="timeline-content fw-mormal text-muted ps-3">Indulging in poorly driving and keep structure keep great</div>-->
          <!--                    &lt;!&ndash;end::Text&ndash;&gt;-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
          <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
          <!--                  <div class="timeline-item">-->
          <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                    <div class="timeline-label fw-bolder text-gray-800 fs-6">21:03</div>-->
          <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Badge&ndash;&gt;-->
          <!--                    <div class="timeline-badge">-->
          <!--                      <i class="fa fa-genderless text-danger fs-1"></i>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Badge&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Desc&ndash;&gt;-->
          <!--                    <div class="timeline-content fw-bold text-gray-800 ps-3">New order placed-->
          <!--                      <a href="#" class="text-primary">#XF-2356</a>.</div>-->
          <!--                    &lt;!&ndash;end::Desc&ndash;&gt;-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
          <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
          <!--                  <div class="timeline-item">-->
          <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                    <div class="timeline-label fw-bolder text-gray-800 fs-6">16:50</div>-->
          <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Badge&ndash;&gt;-->
          <!--                    <div class="timeline-badge">-->
          <!--                      <i class="fa fa-genderless text-primary fs-1"></i>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Badge&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Text&ndash;&gt;-->
          <!--                    <div class="timeline-content fw-mormal text-muted ps-3">Indulging in poorly driving and keep structure keep great</div>-->
          <!--                    &lt;!&ndash;end::Text&ndash;&gt;-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
          <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
          <!--                  <div class="timeline-item">-->
          <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                    <div class="timeline-label fw-bolder text-gray-800 fs-6">21:03</div>-->
          <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Badge&ndash;&gt;-->
          <!--                    <div class="timeline-badge">-->
          <!--                      <i class="fa fa-genderless text-danger fs-1"></i>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Badge&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Desc&ndash;&gt;-->
          <!--                    <div class="timeline-content fw-bold text-gray-800 ps-3">New order placed-->
          <!--                      <a href="#" class="text-primary">#XF-2356</a>.</div>-->
          <!--                    &lt;!&ndash;end::Desc&ndash;&gt;-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
          <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
          <!--                  <div class="timeline-item">-->
          <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
          <!--                    <div class="timeline-label fw-bolder text-gray-800 fs-6">10:30</div>-->
          <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Badge&ndash;&gt;-->
          <!--                    <div class="timeline-badge">-->
          <!--                      <i class="fa fa-genderless text-success fs-1"></i>-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;end::Badge&ndash;&gt;-->
          <!--                    &lt;!&ndash;begin::Text&ndash;&gt;-->
          <!--                    <div class="timeline-content fw-mormal text-muted ps-3">Finance KPI Mobile app launch preparion meeting</div>-->
          <!--                    &lt;!&ndash;end::Text&ndash;&gt;-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
          <!--                </div>-->
          <!--                &lt;!&ndash;end::Timeline&ndash;&gt;-->
          <!--              </div>-->
          <!--              &lt;!&ndash;end: Card Body&ndash;&gt;-->
          <!--            </div>-->
          <!--            &lt;!&ndash;end: List Widget 5&ndash;&gt;-->
          <!--          </div>-->
          <!--          &lt;!&ndash;end::Col&ndash;&gt;-->
          <!--          &lt;!&ndash;begin::Col&ndash;&gt;-->
          <!--          <div class="col-xl-4">-->
          <!--            &lt;!&ndash;begin::Mixed Widget 7&ndash;&gt;-->
          <!--            <div class="card card-xl-stretch-50 mb-5 mb-xl-8">-->
          <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
          <!--              <div class="card-body d-flex flex-column p-0">-->
          <!--                &lt;!&ndash;begin::Stats&ndash;&gt;-->
          <!--                <div class="flex-grow-1 card-p pb-0">-->
          <!--                  <div class="d-flex flex-stack flex-wrap">-->
          <!--                    <div class="me-2">-->
          <!--                      <a href="#" class="text-dark text-hover-primary fw-bolder fs-3">Generate Reports</a>-->
          <!--                      <div class="text-muted fs-7 fw-bold">Finance and accounting reports</div>-->
          <!--                    </div>-->
          <!--                    <div class="fw-bolder fs-3 text-primary">$24,500</div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                &lt;!&ndash;end::Stats&ndash;&gt;-->
          <!--                &lt;!&ndash;begin::Chart&ndash;&gt;-->
          <!--                <div class="mixed-widget-7-chart card-rounded-bottom" data-kt-chart-color="primary" style="height: 150px"></div>-->
          <!--                &lt;!&ndash;end::Chart&ndash;&gt;-->
          <!--              </div>-->
          <!--              &lt;!&ndash;end::Body&ndash;&gt;-->
          <!--            </div>-->
          <!--            &lt;!&ndash;end::Mixed Widget 7&ndash;&gt;-->
          <!--            &lt;!&ndash;begin::Mixed Widget 10&ndash;&gt;-->
          <!--            <div class="card card-xl-stretch-50 mb-5 mb-xl-8">-->
          <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
          <!--              <div class="card-body p-0 d-flex justify-content-between flex-column overflow-hidden">-->
          <!--                &lt;!&ndash;begin::Hidden&ndash;&gt;-->
          <!--                <div class="d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-9 pb-3">-->
          <!--                  <div class="me-2">-->
          <!--                    <span class="fw-bolder text-gray-800 d-block fs-3">Sales</span>-->
          <!--                    <span class="text-gray-400 fw-bold">Oct 8 - Oct 26 22</span>-->
          <!--                  </div>-->
          <!--                  <div class="fw-bolder fs-3 text-primary">$15,300</div>-->
          <!--                </div>-->
          <!--                &lt;!&ndash;end::Hidden&ndash;&gt;-->
          <!--                &lt;!&ndash;begin::Chart&ndash;&gt;-->
          <!--                <div class="mixed-widget-10-chart" data-kt-color="primary" style="height: 175px"></div>-->
          <!--                &lt;!&ndash;end::Chart&ndash;&gt;-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            &lt;!&ndash;end::Mixed Widget 10&ndash;&gt;-->
          <!--          </div>-->
          <!--end::Col-->
        </div>

        <!--end::Row-->
        <!--begin::Row-->
        <!--        <div class="row gy-5 g-xl-8">-->
        <!--          &lt;!&ndash;begin::Col&ndash;&gt;-->
        <!--          <div class="col-xl-4">-->
        <!--            &lt;!&ndash;begin::List Widget 3&ndash;&gt;-->
        <!--            <div class="card card-xl-stretch mb-xl-8">-->
        <!--              &lt;!&ndash;begin::Header&ndash;&gt;-->
        <!--              <div class="card-header border-0">-->
        <!--                <h3 class="card-title fw-bolder text-dark">Todo</h3>-->
        <!--                <div class="card-toolbar">-->
        <!--                  &lt;!&ndash;begin::Menu&ndash;&gt;-->
        <!--                  <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">-->
        <!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen024.svg&ndash;&gt;-->
        <!--                    <span class="svg-icon svg-icon-2">-->
        <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">-->
        <!--																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
        <!--																	<rect x="5" y="5" width="5" height="5" rx="1" fill="#000000" />-->
        <!--																	<rect x="14" y="5" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="5" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="14" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																</g>-->
        <!--															</svg>-->
        <!--														</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                  </button>-->
        <!--                  &lt;!&ndash;begin::Menu 3&ndash;&gt;-->
        <!--                  <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3" data-kt-menu="true">-->
        <!--                    &lt;!&ndash;begin::Heading&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <div class="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">Payments</div>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Heading&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">Create Invoice</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link flex-stack px-3">Create Payment-->
        <!--                        <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title="Specify a target name for future usage and reference"></i></a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">Generate Bill</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-end">-->
        <!--                      <a href="#" class="menu-link px-3">-->
        <!--                        <span class="menu-title">Subscription</span>-->
        <!--                        <span class="menu-arrow"></span>-->
        <!--                      </a>-->
        <!--                      &lt;!&ndash;begin::Menu sub&ndash;&gt;-->
        <!--                      <div class="menu-sub menu-sub-dropdown w-175px py-4">-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Plans</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Billing</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Statements</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu separator&ndash;&gt;-->
        <!--                        <div class="separator my-2"></div>-->
        <!--                        &lt;!&ndash;end::Menu separator&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <div class="menu-content px-3">-->
        <!--                            &lt;!&ndash;begin::Switch&ndash;&gt;-->
        <!--                            <label class="form-check form-switch form-check-custom form-check-solid">-->
        <!--                              &lt;!&ndash;begin::Input&ndash;&gt;-->
        <!--                              <input class="form-check-input w-30px h-20px" type="checkbox" value="1" checked="checked" name="notifications" />-->
        <!--                              &lt;!&ndash;end::Input&ndash;&gt;-->
        <!--                              &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                              <span class="form-check-label text-muted fs-6">Recuring</span>-->
        <!--                              &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                            </label>-->
        <!--                            &lt;!&ndash;end::Switch&ndash;&gt;-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Menu sub&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3 my-1">-->
        <!--                      <a href="#" class="menu-link px-3">Settings</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Menu 3&ndash;&gt;-->
        <!--                  &lt;!&ndash;end::Menu&ndash;&gt;-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Header&ndash;&gt;-->
        <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
        <!--              <div class="card-body pt-2">-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center mb-8">-->
        <!--                  &lt;!&ndash;begin::Bullet&ndash;&gt;-->
        <!--                  <span class="bullet bullet-vertical h-40px bg-success"></span>-->
        <!--                  &lt;!&ndash;end::Bullet&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Checkbox&ndash;&gt;-->
        <!--                  <div class="form-check form-check-custom form-check-solid mx-5">-->
        <!--                    <input class="form-check-input" type="checkbox" value="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Checkbox&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Description&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-gray-800 text-hover-primary fw-bolder fs-6">Create FireStone Logo</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 2 Days</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Description&ndash;&gt;-->
        <!--                  <span class="badge badge-light-success fs-8 fw-bolder">New</span>-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end:Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center mb-8">-->
        <!--                  &lt;!&ndash;begin::Bullet&ndash;&gt;-->
        <!--                  <span class="bullet bullet-vertical h-40px bg-primary"></span>-->
        <!--                  &lt;!&ndash;end::Bullet&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Checkbox&ndash;&gt;-->
        <!--                  <div class="form-check form-check-custom form-check-solid mx-5">-->
        <!--                    <input class="form-check-input" type="checkbox" value="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Checkbox&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Description&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-gray-800 text-hover-primary fw-bolder fs-6">Stakeholder Meeting</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 3 Days</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Description&ndash;&gt;-->
        <!--                  <span class="badge badge-light-primary fs-8 fw-bolder">New</span>-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end:Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center mb-8">-->
        <!--                  &lt;!&ndash;begin::Bullet&ndash;&gt;-->
        <!--                  <span class="bullet bullet-vertical h-40px bg-warning"></span>-->
        <!--                  &lt;!&ndash;end::Bullet&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Checkbox&ndash;&gt;-->
        <!--                  <div class="form-check form-check-custom form-check-solid mx-5">-->
        <!--                    <input class="form-check-input" type="checkbox" value="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Checkbox&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Description&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-gray-800 text-hover-primary fw-bolder fs-6">Scoping &amp; Estimations</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 5 Days</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Description&ndash;&gt;-->
        <!--                  <span class="badge badge-light-warning fs-8 fw-bolder">New</span>-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end:Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center mb-8">-->
        <!--                  &lt;!&ndash;begin::Bullet&ndash;&gt;-->
        <!--                  <span class="bullet bullet-vertical h-40px bg-primary"></span>-->
        <!--                  &lt;!&ndash;end::Bullet&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Checkbox&ndash;&gt;-->
        <!--                  <div class="form-check form-check-custom form-check-solid mx-5">-->
        <!--                    <input class="form-check-input" type="checkbox" value="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Checkbox&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Description&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-gray-800 text-hover-primary fw-bolder fs-6">KPI App Showcase</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 2 Days</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Description&ndash;&gt;-->
        <!--                  <span class="badge badge-light-primary fs-8 fw-bolder">New</span>-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end:Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center mb-8">-->
        <!--                  &lt;!&ndash;begin::Bullet&ndash;&gt;-->
        <!--                  <span class="bullet bullet-vertical h-40px bg-danger"></span>-->
        <!--                  &lt;!&ndash;end::Bullet&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Checkbox&ndash;&gt;-->
        <!--                  <div class="form-check form-check-custom form-check-solid mx-5">-->
        <!--                    <input class="form-check-input" type="checkbox" value="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Checkbox&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Description&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-gray-800 text-hover-primary fw-bolder fs-6">Project Meeting</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 12 Days</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Description&ndash;&gt;-->
        <!--                  <span class="badge badge-light-danger fs-8 fw-bolder">New</span>-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end:Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center">-->
        <!--                  &lt;!&ndash;begin::Bullet&ndash;&gt;-->
        <!--                  <span class="bullet bullet-vertical h-40px bg-success"></span>-->
        <!--                  &lt;!&ndash;end::Bullet&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Checkbox&ndash;&gt;-->
        <!--                  <div class="form-check form-check-custom form-check-solid mx-5">-->
        <!--                    <input class="form-check-input" type="checkbox" value="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Checkbox&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Description&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-gray-800 text-hover-primary fw-bolder fs-6">Customers Update</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 1 week</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Description&ndash;&gt;-->
        <!--                  <span class="badge badge-light-success fs-8 fw-bolder">New</span>-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end:Item&ndash;&gt;-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Body&ndash;&gt;-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end:List Widget 3&ndash;&gt;-->
        <!--          </div>-->
        <!--          &lt;!&ndash;end::Col&ndash;&gt;-->
        <!--          &lt;!&ndash;begin::Col&ndash;&gt;-->
        <!--          <div class="col-xl-8">-->
        <!--            &lt;!&ndash;begin::Tables Widget 9&ndash;&gt;-->
        <!--            <div class="card card-xl-stretch mb-5 mb-xl-8">-->
        <!--              &lt;!&ndash;begin::Header&ndash;&gt;-->
        <!--              <div class="card-header border-0 pt-5">-->
        <!--                <h3 class="card-title align-items-start flex-column">-->
        <!--                  <span class="card-label fw-bolder fs-3 mb-1">Members Statistics</span>-->
        <!--                  <span class="text-muted mt-1 fw-bold fs-7">Over 500 members</span>-->
        <!--                </h3>-->
        <!--                <div class="card-toolbar" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-trigger="hover" title="Click to add a user">-->
        <!--                  <a href="#" class="btn btn-sm btn-light btn-active-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_invite_friends">-->
        <!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr075.svg&ndash;&gt;-->
        <!--                    <span class="svg-icon svg-icon-3">-->
        <!--														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--															<rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1" transform="rotate(-90 11.364 20.364)" fill="black" />-->
        <!--															<rect x="4.36396" y="11.364" width="16" height="2" rx="1" fill="black" />-->
        <!--														</svg>-->
        <!--													</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;New Member</a>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Header&ndash;&gt;-->
        <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
        <!--              <div class="card-body py-3">-->
        <!--                &lt;!&ndash;begin::Table container&ndash;&gt;-->
        <!--                <div class="table-responsive">-->
        <!--                  &lt;!&ndash;begin::Table&ndash;&gt;-->
        <!--                  <table class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">-->
        <!--                    &lt;!&ndash;begin::Table head&ndash;&gt;-->
        <!--                    <thead>-->
        <!--                    <tr class="fw-bolder text-muted">-->
        <!--                      <th class="w-25px">-->
        <!--                        <div class="form-check form-check-sm form-check-custom form-check-solid">-->
        <!--                          <input class="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-9-check" />-->
        <!--                        </div>-->
        <!--                      </th>-->
        <!--                      <th class="min-w-150px">Authors</th>-->
        <!--                      <th class="min-w-140px">Company</th>-->
        <!--                      <th class="min-w-120px">Progress</th>-->
        <!--                      <th class="min-w-100px text-end">Actions</th>-->
        <!--                    </tr>-->
        <!--                    </thead>-->
        <!--                    &lt;!&ndash;end::Table head&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Table body&ndash;&gt;-->
        <!--                    <tbody>-->
        <!--                    <tr>-->
        <!--                      <td>-->
        <!--                        <div class="form-check form-check-sm form-check-custom form-check-solid">-->
        <!--                          <input class="form-check-input widget-9-check" type="checkbox" value="1" />-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex align-items-center">-->
        <!--                          <div class="symbol symbol-45px me-5">-->
        <!--                            <img src="assets/media/avatars/300-14.jpg" alt="" />-->
        <!--                          </div>-->
        <!--                          <div class="d-flex justify-content-start flex-column">-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Ana Simmons</a>-->
        <!--                            <span class="text-muted fw-bold text-muted d-block fs-7">HTML, JS, ReactJS</span>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <a href="#" class="text-dark fw-bolder text-hover-primary d-block fs-6">Intertico</a>-->
        <!--                        <span class="text-muted fw-bold text-muted d-block fs-7">Web, UI/UX Design</span>-->
        <!--                      </td>-->
        <!--                      <td class="text-end">-->
        <!--                        <div class="d-flex flex-column w-100 me-2">-->
        <!--                          <div class="d-flex flex-stack mb-2">-->
        <!--                            <span class="text-muted me-2 fs-7 fw-bold">50%</span>-->
        <!--                          </div>-->
        <!--                          <div class="progress h-6px w-100">-->
        <!--                            <div class="progress-bar bg-primary" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex justify-content-end flex-shrink-0">-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen019.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="black" />-->
        <!--																					<path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/art/art005.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="black" />-->
        <!--																					<path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen027.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                    </tr>-->
        <!--                    <tr>-->
        <!--                      <td>-->
        <!--                        <div class="form-check form-check-sm form-check-custom form-check-solid">-->
        <!--                          <input class="form-check-input widget-9-check" type="checkbox" value="1" />-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex align-items-center">-->
        <!--                          <div class="symbol symbol-45px me-5">-->
        <!--                            <img src="assets/media/avatars/300-2.jpg" alt="" />-->
        <!--                          </div>-->
        <!--                          <div class="d-flex justify-content-start flex-column">-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Jessie Clarcson</a>-->
        <!--                            <span class="text-muted fw-bold text-muted d-block fs-7">C#, ASP.NET, MS SQL</span>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <a href="#" class="text-dark fw-bolder text-hover-primary d-block fs-6">Agoda</a>-->
        <!--                        <span class="text-muted fw-bold text-muted d-block fs-7">Houses &amp; Hotels</span>-->
        <!--                      </td>-->
        <!--                      <td class="text-end">-->
        <!--                        <div class="d-flex flex-column w-100 me-2">-->
        <!--                          <div class="d-flex flex-stack mb-2">-->
        <!--                            <span class="text-muted me-2 fs-7 fw-bold">70%</span>-->
        <!--                          </div>-->
        <!--                          <div class="progress h-6px w-100">-->
        <!--                            <div class="progress-bar bg-danger" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex justify-content-end flex-shrink-0">-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen019.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="black" />-->
        <!--																					<path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/art/art005.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="black" />-->
        <!--																					<path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen027.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                    </tr>-->
        <!--                    <tr>-->
        <!--                      <td>-->
        <!--                        <div class="form-check form-check-sm form-check-custom form-check-solid">-->
        <!--                          <input class="form-check-input widget-9-check" type="checkbox" value="1" />-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex align-items-center">-->
        <!--                          <div class="symbol symbol-45px me-5">-->
        <!--                            <img src="assets/media/avatars/300-5.jpg" alt="" />-->
        <!--                          </div>-->
        <!--                          <div class="d-flex justify-content-start flex-column">-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Lebron Wayde</a>-->
        <!--                            <span class="text-muted fw-bold text-muted d-block fs-7">PHP, Laravel, VueJS</span>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <a href="#" class="text-dark fw-bolder text-hover-primary d-block fs-6">RoadGee</a>-->
        <!--                        <span class="text-muted fw-bold text-muted d-block fs-7">Transportation</span>-->
        <!--                      </td>-->
        <!--                      <td class="text-end">-->
        <!--                        <div class="d-flex flex-column w-100 me-2">-->
        <!--                          <div class="d-flex flex-stack mb-2">-->
        <!--                            <span class="text-muted me-2 fs-7 fw-bold">60%</span>-->
        <!--                          </div>-->
        <!--                          <div class="progress h-6px w-100">-->
        <!--                            <div class="progress-bar bg-success" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex justify-content-end flex-shrink-0">-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen019.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="black" />-->
        <!--																					<path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/art/art005.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="black" />-->
        <!--																					<path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen027.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                    </tr>-->
        <!--                    <tr>-->
        <!--                      <td>-->
        <!--                        <div class="form-check form-check-sm form-check-custom form-check-solid">-->
        <!--                          <input class="form-check-input widget-9-check" type="checkbox" value="1" />-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex align-items-center">-->
        <!--                          <div class="symbol symbol-45px me-5">-->
        <!--                            <img src="assets/media/avatars/300-20.jpg" alt="" />-->
        <!--                          </div>-->
        <!--                          <div class="d-flex justify-content-start flex-column">-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Natali Goodwin</a>-->
        <!--                            <span class="text-muted fw-bold text-muted d-block fs-7">Python, PostgreSQL, ReactJS</span>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <a href="#" class="text-dark fw-bolder text-hover-primary d-block fs-6">The Hill</a>-->
        <!--                        <span class="text-muted fw-bold text-muted d-block fs-7">Insurance</span>-->
        <!--                      </td>-->
        <!--                      <td class="text-end">-->
        <!--                        <div class="d-flex flex-column w-100 me-2">-->
        <!--                          <div class="d-flex flex-stack mb-2">-->
        <!--                            <span class="text-muted me-2 fs-7 fw-bold">50%</span>-->
        <!--                          </div>-->
        <!--                          <div class="progress h-6px w-100">-->
        <!--                            <div class="progress-bar bg-warning" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex justify-content-end flex-shrink-0">-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen019.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="black" />-->
        <!--																					<path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/art/art005.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="black" />-->
        <!--																					<path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen027.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                    </tr>-->
        <!--                    <tr>-->
        <!--                      <td>-->
        <!--                        <div class="form-check form-check-sm form-check-custom form-check-solid">-->
        <!--                          <input class="form-check-input widget-9-check" type="checkbox" value="1" />-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex align-items-center">-->
        <!--                          <div class="symbol symbol-45px me-5">-->
        <!--                            <img src="assets/media/avatars/300-23.jpg" alt="" />-->
        <!--                          </div>-->
        <!--                          <div class="d-flex justify-content-start flex-column">-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Kevin Leonard</a>-->
        <!--                            <span class="text-muted fw-bold text-muted d-block fs-7">HTML, JS, ReactJS</span>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <a href="#" class="text-dark fw-bolder text-hover-primary d-block fs-6">RoadGee</a>-->
        <!--                        <span class="text-muted fw-bold text-muted d-block fs-7">Art Director</span>-->
        <!--                      </td>-->
        <!--                      <td class="text-end">-->
        <!--                        <div class="d-flex flex-column w-100 me-2">-->
        <!--                          <div class="d-flex flex-stack mb-2">-->
        <!--                            <span class="text-muted me-2 fs-7 fw-bold">90%</span>-->
        <!--                          </div>-->
        <!--                          <div class="progress h-6px w-100">-->
        <!--                            <div class="progress-bar bg-info" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                      <td>-->
        <!--                        <div class="d-flex justify-content-end flex-shrink-0">-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen019.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="black" />-->
        <!--																					<path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/art/art005.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="black" />-->
        <!--																					<path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                          <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">-->
        <!--                            &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen027.svg&ndash;&gt;-->
        <!--                            <span class="svg-icon svg-icon-3">-->
        <!--																				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																					<path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="black" />-->
        <!--																					<path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="black" />-->
        <!--																				</svg>-->
        <!--																			</span>-->
        <!--                            &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                          </a>-->
        <!--                        </div>-->
        <!--                      </td>-->
        <!--                    </tr>-->
        <!--                    </tbody>-->
        <!--                    &lt;!&ndash;end::Table body&ndash;&gt;-->
        <!--                  </table>-->
        <!--                  &lt;!&ndash;end::Table&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Table container&ndash;&gt;-->
        <!--              </div>-->
        <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end::Tables Widget 9&ndash;&gt;-->
        <!--          </div>-->
        <!--          &lt;!&ndash;end::Col&ndash;&gt;-->
        <!--        </div>-->
        <!--        &lt;!&ndash;end::Row&ndash;&gt;-->
        <!--        &lt;!&ndash;begin::Row&ndash;&gt;-->
        <!--        <div class="row gy-5 g-xl-8">-->
        <!--          &lt;!&ndash;begin::Col&ndash;&gt;-->
        <!--          <div class="col-xl-4">-->
        <!--            &lt;!&ndash;begin::List Widget 2&ndash;&gt;-->
        <!--            <div class="card card-xl-stretch mb-xl-8">-->
        <!--              &lt;!&ndash;begin::Header&ndash;&gt;-->
        <!--              <div class="card-header border-0">-->
        <!--                <h3 class="card-title fw-bolder text-dark">Authors</h3>-->
        <!--                <div class="card-toolbar">-->
        <!--                  &lt;!&ndash;begin::Menu&ndash;&gt;-->
        <!--                  <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">-->
        <!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen024.svg&ndash;&gt;-->
        <!--                    <span class="svg-icon svg-icon-2">-->
        <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">-->
        <!--																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
        <!--																	<rect x="5" y="5" width="5" height="5" rx="1" fill="#000000" />-->
        <!--																	<rect x="14" y="5" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="5" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="14" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																</g>-->
        <!--															</svg>-->
        <!--														</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                  </button>-->
        <!--                  &lt;!&ndash;begin::Menu 2&ndash;&gt;-->
        <!--                  <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px" data-kt-menu="true">-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <div class="menu-content fs-6 text-dark fw-bolder px-3 py-4">Quick Actions</div>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu separator&ndash;&gt;-->
        <!--                    <div class="separator mb-3 opacity-75"></div>-->
        <!--                    &lt;!&ndash;end::Menu separator&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">New Ticket</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">New Customer</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">-->
        <!--                      &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                      <a href="#" class="menu-link px-3">-->
        <!--                        <span class="menu-title">New Group</span>-->
        <!--                        <span class="menu-arrow"></span>-->
        <!--                      </a>-->
        <!--                      &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                      &lt;!&ndash;begin::Menu sub&ndash;&gt;-->
        <!--                      <div class="menu-sub menu-sub-dropdown w-175px py-4">-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Admin Group</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Staff Group</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Member Group</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Menu sub&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">New Contact</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu separator&ndash;&gt;-->
        <!--                    <div class="separator mt-3 opacity-75"></div>-->
        <!--                    &lt;!&ndash;end::Menu separator&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <div class="menu-content px-3 py-3">-->
        <!--                        <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>-->
        <!--                      </div>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Menu 2&ndash;&gt;-->
        <!--                  &lt;!&ndash;end::Menu&ndash;&gt;-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Header&ndash;&gt;-->
        <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
        <!--              <div class="card-body pt-2">-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center mb-7">-->
        <!--                  &lt;!&ndash;begin::Avatar&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--                    <img src="assets/media/avatars/300-6.jpg" class="" alt="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Avatar&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Text&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Emma Smith</a>-->
        <!--                    <span class="text-muted d-block fw-bold">Project Manager</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Text&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center mb-7">-->
        <!--                  &lt;!&ndash;begin::Avatar&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--                    <img src="assets/media/avatars/300-5.jpg" class="" alt="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Avatar&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Text&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Sean Bean</a>-->
        <!--                    <span class="text-muted d-block fw-bold">PHP, SQLite, Artisan CLI</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Text&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center mb-7">-->
        <!--                  &lt;!&ndash;begin::Avatar&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--                    <img src="assets/media/avatars/300-11.jpg" class="" alt="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Avatar&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Text&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Brian Cox</a>-->
        <!--                    <span class="text-muted d-block fw-bold">PHP, SQLite, Artisan CLI</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Text&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center mb-7">-->
        <!--                  &lt;!&ndash;begin::Avatar&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--                    <img src="assets/media/avatars/300-9.jpg" class="" alt="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Avatar&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Text&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Francis Mitcham</a>-->
        <!--                    <span class="text-muted d-block fw-bold">PHP, SQLite, Artisan CLI</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Text&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center">-->
        <!--                  &lt;!&ndash;begin::Avatar&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--                    <img src="assets/media/avatars/300-23.jpg" class="" alt="" />-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Avatar&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Text&ndash;&gt;-->
        <!--                  <div class="flex-grow-1">-->
        <!--                    <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">Dan Wilson</a>-->
        <!--                    <span class="text-muted d-block fw-bold">PHP, SQLite, Artisan CLI</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Text&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Body&ndash;&gt;-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end::List Widget 2&ndash;&gt;-->
        <!--          </div>-->
        <!--          &lt;!&ndash;end::Col&ndash;&gt;-->
        <!--          &lt;!&ndash;begin::Col&ndash;&gt;-->
        <!--          <div class="col-xl-4">-->
        <!--            &lt;!&ndash;begin::List Widget 6&ndash;&gt;-->
        <!--            <div class="card card-xl-stretch mb-xl-8">-->
        <!--              &lt;!&ndash;begin::Header&ndash;&gt;-->
        <!--              <div class="card-header border-0">-->
        <!--                <h3 class="card-title fw-bolder text-dark">Notifications</h3>-->
        <!--                <div class="card-toolbar">-->
        <!--                  &lt;!&ndash;begin::Menu&ndash;&gt;-->
        <!--                  <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">-->
        <!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen024.svg&ndash;&gt;-->
        <!--                    <span class="svg-icon svg-icon-2">-->
        <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">-->
        <!--																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
        <!--																	<rect x="5" y="5" width="5" height="5" rx="1" fill="#000000" />-->
        <!--																	<rect x="14" y="5" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="5" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="14" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																</g>-->
        <!--															</svg>-->
        <!--														</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                  </button>-->
        <!--                  &lt;!&ndash;begin::Menu 3&ndash;&gt;-->
        <!--                  <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3" data-kt-menu="true">-->
        <!--                    &lt;!&ndash;begin::Heading&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <div class="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">Payments</div>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Heading&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">Create Invoice</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link flex-stack px-3">Create Payment-->
        <!--                        <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title="Specify a target name for future usage and reference"></i></a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">Generate Bill</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-end">-->
        <!--                      <a href="#" class="menu-link px-3">-->
        <!--                        <span class="menu-title">Subscription</span>-->
        <!--                        <span class="menu-arrow"></span>-->
        <!--                      </a>-->
        <!--                      &lt;!&ndash;begin::Menu sub&ndash;&gt;-->
        <!--                      <div class="menu-sub menu-sub-dropdown w-175px py-4">-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Plans</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Billing</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Statements</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu separator&ndash;&gt;-->
        <!--                        <div class="separator my-2"></div>-->
        <!--                        &lt;!&ndash;end::Menu separator&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <div class="menu-content px-3">-->
        <!--                            &lt;!&ndash;begin::Switch&ndash;&gt;-->
        <!--                            <label class="form-check form-switch form-check-custom form-check-solid">-->
        <!--                              &lt;!&ndash;begin::Input&ndash;&gt;-->
        <!--                              <input class="form-check-input w-30px h-20px" type="checkbox" value="1" checked="checked" name="notifications" />-->
        <!--                              &lt;!&ndash;end::Input&ndash;&gt;-->
        <!--                              &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                              <span class="form-check-label text-muted fs-6">Recuring</span>-->
        <!--                              &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                            </label>-->
        <!--                            &lt;!&ndash;end::Switch&ndash;&gt;-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Menu sub&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3 my-1">-->
        <!--                      <a href="#" class="menu-link px-3">Settings</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Menu 3&ndash;&gt;-->
        <!--                  &lt;!&ndash;end::Menu&ndash;&gt;-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Header&ndash;&gt;-->
        <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
        <!--              <div class="card-body pt-0">-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center bg-light-warning rounded p-5 mb-7">-->
        <!--                  &lt;!&ndash;begin::Icon&ndash;&gt;-->
        <!--                  <span class="svg-icon svg-icon-warning me-5">-->
        <!--														&lt;!&ndash;begin::Svg Icon | path: icons/duotune/abstract/abs027.svg&ndash;&gt;-->
        <!--														<span class="svg-icon svg-icon-1">-->
        <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																<path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="black" />-->
        <!--																<path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="black" />-->
        <!--															</svg>-->
        <!--														</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--													</span>-->
        <!--                  &lt;!&ndash;end::Icon&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Title&ndash;&gt;-->
        <!--                  <div class="flex-grow-1 me-2">-->
        <!--                    <a href="#" class="fw-bolder text-gray-800 text-hover-primary fs-6">Group lunch celebration</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 2 Days</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Title&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Lable&ndash;&gt;-->
        <!--                  <span class="fw-bolder text-warning py-1">+28%</span>-->
        <!--                  &lt;!&ndash;end::Lable&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center bg-light-success rounded p-5 mb-7">-->
        <!--                  &lt;!&ndash;begin::Icon&ndash;&gt;-->
        <!--                  <span class="svg-icon svg-icon-success me-5">-->
        <!--														&lt;!&ndash;begin::Svg Icon | path: icons/duotune/abstract/abs027.svg&ndash;&gt;-->
        <!--														<span class="svg-icon svg-icon-1">-->
        <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																<path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="black" />-->
        <!--																<path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="black" />-->
        <!--															</svg>-->
        <!--														</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--													</span>-->
        <!--                  &lt;!&ndash;end::Icon&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Title&ndash;&gt;-->
        <!--                  <div class="flex-grow-1 me-2">-->
        <!--                    <a href="#" class="fw-bolder text-gray-800 text-hover-primary fs-6">Navigation optimization</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 2 Days</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Title&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Lable&ndash;&gt;-->
        <!--                  <span class="fw-bolder text-success py-1">+50%</span>-->
        <!--                  &lt;!&ndash;end::Lable&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center bg-light-danger rounded p-5 mb-7">-->
        <!--                  &lt;!&ndash;begin::Icon&ndash;&gt;-->
        <!--                  <span class="svg-icon svg-icon-danger me-5">-->
        <!--														&lt;!&ndash;begin::Svg Icon | path: icons/duotune/abstract/abs027.svg&ndash;&gt;-->
        <!--														<span class="svg-icon svg-icon-1">-->
        <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																<path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="black" />-->
        <!--																<path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="black" />-->
        <!--															</svg>-->
        <!--														</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--													</span>-->
        <!--                  &lt;!&ndash;end::Icon&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Title&ndash;&gt;-->
        <!--                  <div class="flex-grow-1 me-2">-->
        <!--                    <a href="#" class="fw-bolder text-gray-800 text-hover-primary fs-6">Rebrand strategy planning</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 5 Days</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Title&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Lable&ndash;&gt;-->
        <!--                  <span class="fw-bolder text-danger py-1">-27%</span>-->
        <!--                  &lt;!&ndash;end::Lable&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-center bg-light-info rounded p-5">-->
        <!--                  &lt;!&ndash;begin::Icon&ndash;&gt;-->
        <!--                  <span class="svg-icon svg-icon-info me-5">-->
        <!--														&lt;!&ndash;begin::Svg Icon | path: icons/duotune/abstract/abs027.svg&ndash;&gt;-->
        <!--														<span class="svg-icon svg-icon-1">-->
        <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																<path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="black" />-->
        <!--																<path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="black" />-->
        <!--															</svg>-->
        <!--														</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--													</span>-->
        <!--                  &lt;!&ndash;end::Icon&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Title&ndash;&gt;-->
        <!--                  <div class="flex-grow-1 me-2">-->
        <!--                    <a href="#" class="fw-bolder text-gray-800 text-hover-primary fs-6">Product goals strategy</a>-->
        <!--                    <span class="text-muted fw-bold d-block">Due in 7 Days</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Title&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Lable&ndash;&gt;-->
        <!--                  <span class="fw-bolder text-info py-1">+8%</span>-->
        <!--                  &lt;!&ndash;end::Lable&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Body&ndash;&gt;-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end::List Widget 6&ndash;&gt;-->
        <!--          </div>-->
        <!--          &lt;!&ndash;end::Col&ndash;&gt;-->
        <!--          &lt;!&ndash;begin::Col&ndash;&gt;-->
        <!--          <div class="col-xl-4">-->
        <!--            &lt;!&ndash;begin::List Widget 4&ndash;&gt;-->
        <!--            <div class="card card-xl-stretch mb-5 mb-xl-8">-->
        <!--              &lt;!&ndash;begin::Header&ndash;&gt;-->
        <!--              <div class="card-header border-0 pt-5">-->
        <!--                <h3 class="card-title align-items-start flex-column">-->
        <!--                  <span class="card-label fw-bolder text-dark">Trends</span>-->
        <!--                  <span class="text-muted mt-1 fw-bold fs-7">Latest tech trends</span>-->
        <!--                </h3>-->
        <!--                <div class="card-toolbar">-->
        <!--                  &lt;!&ndash;begin::Menu&ndash;&gt;-->
        <!--                  <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">-->
        <!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen024.svg&ndash;&gt;-->
        <!--                    <span class="svg-icon svg-icon-2">-->
        <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">-->
        <!--																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
        <!--																	<rect x="5" y="5" width="5" height="5" rx="1" fill="#000000" />-->
        <!--																	<rect x="14" y="5" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="5" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="14" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																</g>-->
        <!--															</svg>-->
        <!--														</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                  </button>-->
        <!--                  &lt;!&ndash;begin::Menu 3&ndash;&gt;-->
        <!--                  <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3" data-kt-menu="true">-->
        <!--                    &lt;!&ndash;begin::Heading&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <div class="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">Payments</div>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Heading&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">Create Invoice</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link flex-stack px-3">Create Payment-->
        <!--                        <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title="Specify a target name for future usage and reference"></i></a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">Generate Bill</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-end">-->
        <!--                      <a href="#" class="menu-link px-3">-->
        <!--                        <span class="menu-title">Subscription</span>-->
        <!--                        <span class="menu-arrow"></span>-->
        <!--                      </a>-->
        <!--                      &lt;!&ndash;begin::Menu sub&ndash;&gt;-->
        <!--                      <div class="menu-sub menu-sub-dropdown w-175px py-4">-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Plans</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Billing</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Statements</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu separator&ndash;&gt;-->
        <!--                        <div class="separator my-2"></div>-->
        <!--                        &lt;!&ndash;end::Menu separator&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <div class="menu-content px-3">-->
        <!--                            &lt;!&ndash;begin::Switch&ndash;&gt;-->
        <!--                            <label class="form-check form-switch form-check-custom form-check-solid">-->
        <!--                              &lt;!&ndash;begin::Input&ndash;&gt;-->
        <!--                              <input class="form-check-input w-30px h-20px" type="checkbox" value="1" checked="checked" name="notifications" />-->
        <!--                              &lt;!&ndash;end::Input&ndash;&gt;-->
        <!--                              &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                              <span class="form-check-label text-muted fs-6">Recuring</span>-->
        <!--                              &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                            </label>-->
        <!--                            &lt;!&ndash;end::Switch&ndash;&gt;-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Menu sub&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3 my-1">-->
        <!--                      <a href="#" class="menu-link px-3">Settings</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Menu 3&ndash;&gt;-->
        <!--                  &lt;!&ndash;end::Menu&ndash;&gt;-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Header&ndash;&gt;-->
        <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
        <!--              <div class="card-body pt-5">-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-sm-center mb-7">-->
        <!--                  &lt;!&ndash;begin::Symbol&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--														<span class="symbol-label">-->
        <!--															<img src="assets/media/svg/brand-logos/plurk.svg" class="h-50 align-self-center" alt="" />-->
        <!--														</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Symbol&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Section&ndash;&gt;-->
        <!--                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">-->
        <!--                    <div class="flex-grow-1 me-2">-->
        <!--                      <a href="#" class="text-gray-800 text-hover-primary fs-6 fw-bolder">Top Authors</a>-->
        <!--                      <span class="text-muted fw-bold d-block fs-7">Mark, Rowling, Esther</span>-->
        <!--                    </div>-->
        <!--                    <span class="badge badge-light fw-bolder my-2">+82$</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Section&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-sm-center mb-7">-->
        <!--                  &lt;!&ndash;begin::Symbol&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--														<span class="symbol-label">-->
        <!--															<img src="assets/media/svg/brand-logos/telegram.svg" class="h-50 align-self-center" alt="" />-->
        <!--														</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Symbol&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Section&ndash;&gt;-->
        <!--                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">-->
        <!--                    <div class="flex-grow-1 me-2">-->
        <!--                      <a href="#" class="text-gray-800 text-hover-primary fs-6 fw-bolder">Popular Authors</a>-->
        <!--                      <span class="text-muted fw-bold d-block fs-7">Randy, Steve, Mike</span>-->
        <!--                    </div>-->
        <!--                    <span class="badge badge-light fw-bolder my-2">+280$</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Section&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-sm-center mb-7">-->
        <!--                  &lt;!&ndash;begin::Symbol&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--														<span class="symbol-label">-->
        <!--															<img src="assets/media/svg/brand-logos/vimeo.svg" class="h-50 align-self-center" alt="" />-->
        <!--														</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Symbol&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Section&ndash;&gt;-->
        <!--                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">-->
        <!--                    <div class="flex-grow-1 me-2">-->
        <!--                      <a href="#" class="text-gray-800 text-hover-primary fs-6 fw-bolder">New Users</a>-->
        <!--                      <span class="text-muted fw-bold d-block fs-7">John, Pat, Jimmy</span>-->
        <!--                    </div>-->
        <!--                    <span class="badge badge-light fw-bolder my-2">+4500$</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Section&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-sm-center mb-7">-->
        <!--                  &lt;!&ndash;begin::Symbol&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--														<span class="symbol-label">-->
        <!--															<img src="assets/media/svg/brand-logos/bebo.svg" class="h-50 align-self-center" alt="" />-->
        <!--														</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Symbol&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Section&ndash;&gt;-->
        <!--                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">-->
        <!--                    <div class="flex-grow-1 me-2">-->
        <!--                      <a href="#" class="text-gray-800 text-hover-primary fs-6 fw-bolder">Active Customers</a>-->
        <!--                      <span class="text-muted fw-bold d-block fs-7">Mark, Rowling, Esther</span>-->
        <!--                    </div>-->
        <!--                    <span class="badge badge-light fw-bolder my-2">+686$</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Section&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                <div class="d-flex align-items-sm-center mb-7">-->
        <!--                  &lt;!&ndash;begin::Symbol&ndash;&gt;-->
        <!--                  <div class="symbol symbol-50px me-5">-->
        <!--														<span class="symbol-label">-->
        <!--															<img src="assets/media/svg/brand-logos/kickstarter.svg" class="h-50 align-self-center" alt="" />-->
        <!--														</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Symbol&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Section&ndash;&gt;-->
        <!--                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">-->
        <!--                    <div class="flex-grow-1 me-2">-->
        <!--                      <a href="#" class="text-gray-800 text-hover-primary fs-6 fw-bolder">Bestseller Theme</a>-->
        <!--                      <span class="text-muted fw-bold d-block fs-7">Disco, Retro, Sports</span>-->
        <!--                    </div>-->
        <!--                    <span class="badge badge-light fw-bolder my-2">+726$</span>-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Section&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Body&ndash;&gt;-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end::List Widget 4&ndash;&gt;-->
        <!--          </div>-->
        <!--          &lt;!&ndash;end::Col&ndash;&gt;-->
        <!--        </div>-->
        <!--        &lt;!&ndash;end::Row&ndash;&gt;-->
        <!--        &lt;!&ndash;begin::Row&ndash;&gt;-->
        <!--        <div class="row g-5 g-xl-8">-->
        <!--          &lt;!&ndash;begin::Col&ndash;&gt;-->
        <!--          <div class="col-xl-4">-->
        <!--            &lt;!&ndash;begin::Mixed Widget 5&ndash;&gt;-->
        <!--            <div class="card card-xxl-stretch mb-xl-8">-->
        <!--              &lt;!&ndash;begin::Beader&ndash;&gt;-->
        <!--              <div class="card-header border-0 py-5">-->
        <!--                <h3 class="card-title align-items-start flex-column">-->
        <!--                  <span class="card-label fw-bolder fs-3 mb-1">Trends</span>-->
        <!--                  <span class="text-muted fw-bold fs-7">Latest trends</span>-->
        <!--                </h3>-->
        <!--                <div class="card-toolbar">-->
        <!--                  &lt;!&ndash;begin::Menu&ndash;&gt;-->
        <!--                  <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">-->
        <!--                    &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen024.svg&ndash;&gt;-->
        <!--                    <span class="svg-icon svg-icon-2">-->
        <!--															<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">-->
        <!--																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
        <!--																	<rect x="5" y="5" width="5" height="5" rx="1" fill="#000000" />-->
        <!--																	<rect x="14" y="5" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="5" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																	<rect x="14" y="14" width="5" height="5" rx="1" fill="#000000" opacity="0.3" />-->
        <!--																</g>-->
        <!--															</svg>-->
        <!--														</span>-->
        <!--                    &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                  </button>-->
        <!--                  &lt;!&ndash;begin::Menu 3&ndash;&gt;-->
        <!--                  <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3" data-kt-menu="true">-->
        <!--                    &lt;!&ndash;begin::Heading&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <div class="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">Payments</div>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Heading&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">Create Invoice</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link flex-stack px-3">Create Payment-->
        <!--                        <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title="Specify a target name for future usage and reference"></i></a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3">-->
        <!--                      <a href="#" class="menu-link px-3">Generate Bill</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-end">-->
        <!--                      <a href="#" class="menu-link px-3">-->
        <!--                        <span class="menu-title">Subscription</span>-->
        <!--                        <span class="menu-arrow"></span>-->
        <!--                      </a>-->
        <!--                      &lt;!&ndash;begin::Menu sub&ndash;&gt;-->
        <!--                      <div class="menu-sub menu-sub-dropdown w-175px py-4">-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Plans</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Billing</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <a href="#" class="menu-link px-3">Statements</a>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu separator&ndash;&gt;-->
        <!--                        <div class="separator my-2"></div>-->
        <!--                        &lt;!&ndash;end::Menu separator&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                        <div class="menu-item px-3">-->
        <!--                          <div class="menu-content px-3">-->
        <!--                            &lt;!&ndash;begin::Switch&ndash;&gt;-->
        <!--                            <label class="form-check form-switch form-check-custom form-check-solid">-->
        <!--                              &lt;!&ndash;begin::Input&ndash;&gt;-->
        <!--                              <input class="form-check-input w-30px h-20px" type="checkbox" value="1" checked="checked" name="notifications" />-->
        <!--                              &lt;!&ndash;end::Input&ndash;&gt;-->
        <!--                              &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                              <span class="form-check-label text-muted fs-6">Recuring</span>-->
        <!--                              &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                            </label>-->
        <!--                            &lt;!&ndash;end::Switch&ndash;&gt;-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Menu sub&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Menu item&ndash;&gt;-->
        <!--                    <div class="menu-item px-3 my-1">-->
        <!--                      <a href="#" class="menu-link px-3">Settings</a>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Menu item&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Menu 3&ndash;&gt;-->
        <!--                  &lt;!&ndash;end::Menu&ndash;&gt;-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Header&ndash;&gt;-->
        <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
        <!--              <div class="card-body d-flex flex-column">-->
        <!--                &lt;!&ndash;begin::Chart&ndash;&gt;-->
        <!--                <div class="mixed-widget-5-chart card-rounded-top" data-kt-chart-color="success" style="height: 150px"></div>-->
        <!--                &lt;!&ndash;end::Chart&ndash;&gt;-->
        <!--                &lt;!&ndash;begin::Items&ndash;&gt;-->
        <!--                <div class="mt-5">-->
        <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                  <div class="d-flex flex-stack mb-5">-->
        <!--                    &lt;!&ndash;begin::Section&ndash;&gt;-->
        <!--                    <div class="d-flex align-items-center me-2">-->
        <!--                      &lt;!&ndash;begin::Symbol&ndash;&gt;-->
        <!--                      <div class="symbol symbol-50px me-3">-->
        <!--                        <div class="symbol-label bg-light">-->
        <!--                          <img src="assets/media/svg/brand-logos/plurk.svg" class="h-50" alt="" />-->
        <!--                        </div>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Symbol&ndash;&gt;-->
        <!--                      &lt;!&ndash;begin::Title&ndash;&gt;-->
        <!--                      <div>-->
        <!--                        <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">Top Authors</a>-->
        <!--                        <div class="fs-7 text-muted fw-bold mt-1">Ricky Hunt, Sandra Trepp</div>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Title&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Section&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
        <!--                    <div class="badge badge-light fw-bold py-4 px-3">+82$</div>-->
        <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                  <div class="d-flex flex-stack mb-5">-->
        <!--                    &lt;!&ndash;begin::Section&ndash;&gt;-->
        <!--                    <div class="d-flex align-items-center me-2">-->
        <!--                      &lt;!&ndash;begin::Symbol&ndash;&gt;-->
        <!--                      <div class="symbol symbol-50px me-3">-->
        <!--                        <div class="symbol-label bg-light">-->
        <!--                          <img src="assets/media/svg/brand-logos/figma-1.svg" class="h-50" alt="" />-->
        <!--                        </div>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Symbol&ndash;&gt;-->
        <!--                      &lt;!&ndash;begin::Title&ndash;&gt;-->
        <!--                      <div>-->
        <!--                        <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">Top Sales</a>-->
        <!--                        <div class="fs-7 text-muted fw-bold mt-1">PitStop Emails</div>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Title&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Section&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
        <!--                    <div class="badge badge-light fw-bold py-4 px-3">+82$</div>-->
        <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Item&ndash;&gt;-->
        <!--                  <div class="d-flex flex-stack">-->
        <!--                    &lt;!&ndash;begin::Section&ndash;&gt;-->
        <!--                    <div class="d-flex align-items-center me-2">-->
        <!--                      &lt;!&ndash;begin::Symbol&ndash;&gt;-->
        <!--                      <div class="symbol symbol-50px me-3">-->
        <!--                        <div class="symbol-label bg-light">-->
        <!--                          <img src="assets/media/svg/brand-logos/vimeo.svg" class="h-50" alt="" />-->
        <!--                        </div>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Symbol&ndash;&gt;-->
        <!--                      &lt;!&ndash;begin::Title&ndash;&gt;-->
        <!--                      <div class="py-1">-->
        <!--                        <a href="#" class="fs-6 text-gray-800 text-hover-primary fw-bolder">Top Engagement</a>-->
        <!--                        <div class="fs-7 text-muted fw-bold mt-1">KT.com</div>-->
        <!--                      </div>-->
        <!--                      &lt;!&ndash;end::Title&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Section&ndash;&gt;-->
        <!--                    &lt;!&ndash;begin::Label&ndash;&gt;-->
        <!--                    <div class="badge badge-light fw-bold py-4 px-3">+82$</div>-->
        <!--                    &lt;!&ndash;end::Label&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Item&ndash;&gt;-->
        <!--                </div>-->
        <!--                &lt;!&ndash;end::Items&ndash;&gt;-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Body&ndash;&gt;-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end::Mixed Widget 5&ndash;&gt;-->
        <!--          </div>-->
        <!--          &lt;!&ndash;end::Col&ndash;&gt;-->
        <!--          &lt;!&ndash;begin::Col&ndash;&gt;-->
        <!--          <div class="col-xl-8">-->
        <!--            &lt;!&ndash;begin::Tables Widget 5&ndash;&gt;-->
        <!--            <div class="card card-xxl-stretch mb-5 mb-xl-8">-->
        <!--              &lt;!&ndash;begin::Header&ndash;&gt;-->
        <!--              <div class="card-header border-0 pt-5">-->
        <!--                <h3 class="card-title align-items-start flex-column">-->
        <!--                  <span class="card-label fw-bolder fs-3 mb-1">Latest Products</span>-->
        <!--                  <span class="text-muted mt-1 fw-bold fs-7">More than 400 new products</span>-->
        <!--                </h3>-->
        <!--                <div class="card-toolbar">-->
        <!--                  <ul class="nav">-->
        <!--                    <li class="nav-item">-->
        <!--                      <a class="nav-link btn btn-sm btn-color-muted btn-active btn-active-secondary fw-bolder px-4 me-1 active" data-bs-toggle="tab" href="#kt_table_widget_5_tab_1">Month</a>-->
        <!--                    </li>-->
        <!--                    <li class="nav-item">-->
        <!--                      <a class="nav-link btn btn-sm btn-color-muted btn-active btn-active-secondary fw-bolder px-4 me-1" data-bs-toggle="tab" href="#kt_table_widget_5_tab_2">Week</a>-->
        <!--                    </li>-->
        <!--                    <li class="nav-item">-->
        <!--                      <a class="nav-link btn btn-sm btn-color-muted btn-active btn-active-secondary fw-bolder px-4" data-bs-toggle="tab" href="#kt_table_widget_5_tab_3">Day</a>-->
        <!--                    </li>-->
        <!--                  </ul>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Header&ndash;&gt;-->
        <!--              &lt;!&ndash;begin::Body&ndash;&gt;-->
        <!--              <div class="card-body py-3">-->
        <!--                <div class="tab-content">-->
        <!--                  &lt;!&ndash;begin::Tap pane&ndash;&gt;-->
        <!--                  <div class="tab-pane fade show active" id="kt_table_widget_5_tab_1">-->
        <!--                    &lt;!&ndash;begin::Table container&ndash;&gt;-->
        <!--                    <div class="table-responsive">-->
        <!--                      &lt;!&ndash;begin::Table&ndash;&gt;-->
        <!--                      <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4">-->
        <!--                        &lt;!&ndash;begin::Table head&ndash;&gt;-->
        <!--                        <thead>-->
        <!--                        <tr class="border-0">-->
        <!--                          <th class="p-0 w-50px"></th>-->
        <!--                          <th class="p-0 min-w-150px"></th>-->
        <!--                          <th class="p-0 min-w-140px"></th>-->
        <!--                          <th class="p-0 min-w-110px"></th>-->
        <!--                          <th class="p-0 min-w-50px"></th>-->
        <!--                        </tr>-->
        <!--                        </thead>-->
        <!--                        &lt;!&ndash;end::Table head&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Table body&ndash;&gt;-->
        <!--                        <tbody>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/plurk.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Brad Simmons</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Movie Creator</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">React, HTML</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-success">Approved</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/telegram.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Popular Authors</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Most Successful</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">Python, MySQL</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-warning">In Progress</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/vimeo.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">New Users</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Awesome Users</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">Laravel,Metronic</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-primary">Success</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/bebo.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Active Customers</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Movie Creator</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">AngularJS, C#</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-danger">Rejected</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/kickstarter.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Bestseller Theme</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Best Customers</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">ReactJS, Ruby</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-warning">In Progress</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        </tbody>-->
        <!--                        &lt;!&ndash;end::Table body&ndash;&gt;-->
        <!--                      </table>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Table&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Tap pane&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Tap pane&ndash;&gt;-->
        <!--                  <div class="tab-pane fade" id="kt_table_widget_5_tab_2">-->
        <!--                    &lt;!&ndash;begin::Table container&ndash;&gt;-->
        <!--                    <div class="table-responsive">-->
        <!--                      &lt;!&ndash;begin::Table&ndash;&gt;-->
        <!--                      <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4">-->
        <!--                        &lt;!&ndash;begin::Table head&ndash;&gt;-->
        <!--                        <thead>-->
        <!--                        <tr class="border-0">-->
        <!--                          <th class="p-0 w-50px"></th>-->
        <!--                          <th class="p-0 min-w-150px"></th>-->
        <!--                          <th class="p-0 min-w-140px"></th>-->
        <!--                          <th class="p-0 min-w-110px"></th>-->
        <!--                          <th class="p-0 min-w-50px"></th>-->
        <!--                        </tr>-->
        <!--                        </thead>-->
        <!--                        &lt;!&ndash;end::Table head&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Table body&ndash;&gt;-->
        <!--                        <tbody>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/plurk.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Brad Simmons</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Movie Creator</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">React, HTML</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-success">Approved</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/telegram.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Popular Authors</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Most Successful</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">Python, MySQL</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-warning">In Progress</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/bebo.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Active Customers</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Movie Creator</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">AngularJS, C#</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-danger">Rejected</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        </tbody>-->
        <!--                        &lt;!&ndash;end::Table body&ndash;&gt;-->
        <!--                      </table>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Table&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Tap pane&ndash;&gt;-->
        <!--                  &lt;!&ndash;begin::Tap pane&ndash;&gt;-->
        <!--                  <div class="tab-pane fade" id="kt_table_widget_5_tab_3">-->
        <!--                    &lt;!&ndash;begin::Table container&ndash;&gt;-->
        <!--                    <div class="table-responsive">-->
        <!--                      &lt;!&ndash;begin::Table&ndash;&gt;-->
        <!--                      <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4">-->
        <!--                        &lt;!&ndash;begin::Table head&ndash;&gt;-->
        <!--                        <thead>-->
        <!--                        <tr class="border-0">-->
        <!--                          <th class="p-0 w-50px"></th>-->
        <!--                          <th class="p-0 min-w-150px"></th>-->
        <!--                          <th class="p-0 min-w-140px"></th>-->
        <!--                          <th class="p-0 min-w-110px"></th>-->
        <!--                          <th class="p-0 min-w-50px"></th>-->
        <!--                        </tr>-->
        <!--                        </thead>-->
        <!--                        &lt;!&ndash;end::Table head&ndash;&gt;-->
        <!--                        &lt;!&ndash;begin::Table body&ndash;&gt;-->
        <!--                        <tbody>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/kickstarter.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Bestseller Theme</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Best Customers</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">ReactJS, Ruby</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-warning">In Progress</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/bebo.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Active Customers</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Movie Creator</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">AngularJS, C#</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-danger">Rejected</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/vimeo.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">New Users</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Awesome Users</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">Laravel,Metronic</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-primary">Success</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        <tr>-->
        <!--                          <td>-->
        <!--                            <div class="symbol symbol-45px me-2">-->
        <!--																				<span class="symbol-label">-->
        <!--																					<img src="assets/media/svg/brand-logos/telegram.svg" class="h-50 align-self-center" alt="" />-->
        <!--																				</span>-->
        <!--                            </div>-->
        <!--                          </td>-->
        <!--                          <td>-->
        <!--                            <a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">Popular Authors</a>-->
        <!--                            <span class="text-muted fw-bold d-block">Most Successful</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end text-muted fw-bold">Python, MySQL</td>-->
        <!--                          <td class="text-end">-->
        <!--                            <span class="badge badge-light-warning">In Progress</span>-->
        <!--                          </td>-->
        <!--                          <td class="text-end">-->
        <!--                            <a href="#" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary">-->
        <!--                              &lt;!&ndash;begin::Svg Icon | path: icons/duotune/arrows/arr064.svg&ndash;&gt;-->
        <!--                              <span class="svg-icon svg-icon-2">-->
        <!--																					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--																						<rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black" />-->
        <!--																						<path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black" />-->
        <!--																					</svg>-->
        <!--																				</span>-->
        <!--                              &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--                            </a>-->
        <!--                          </td>-->
        <!--                        </tr>-->
        <!--                        </tbody>-->
        <!--                        &lt;!&ndash;end::Table body&ndash;&gt;-->
        <!--                      </table>-->
        <!--                    </div>-->
        <!--                    &lt;!&ndash;end::Table&ndash;&gt;-->
        <!--                  </div>-->
        <!--                  &lt;!&ndash;end::Tap pane&ndash;&gt;-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              &lt;!&ndash;end::Body&ndash;&gt;-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end::Tables Widget 5&ndash;&gt;-->
        <!--          </div>-->
        <!--          &lt;!&ndash;end::Col&ndash;&gt;-->
        <!--        </div>-->
        <!--        &lt;!&ndash;end::Row&ndash;&gt;-->
        <!--        &lt;!&ndash;begin::Calendar Widget 1&ndash;&gt;-->
        <!--        <div class="card">-->
        <!--          &lt;!&ndash;begin::Card header&ndash;&gt;-->
        <!--          <div class="card-header">-->
        <!--            <h3 class="card-title align-items-start flex-column">-->
        <!--              <span class="card-label fw-bolder text-dark">My Calendar</span>-->
        <!--              <span class="text-muted mt-1 fw-bold fs-7">Preview monthly events</span>-->
        <!--            </h3>-->
        <!--            <div class="card-toolbar">-->
        <!--              <a href="../../demo1/dist/apps/calendar.html" class="btn btn-primary">Manage Calendar</a>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          &lt;!&ndash;end::Card header&ndash;&gt;-->
        <!--          &lt;!&ndash;begin::Card body&ndash;&gt;-->
        <!--          <div class="card-body">-->
        <!--            &lt;!&ndash;begin::Calendar&ndash;&gt;-->
        <!--            <div id="kt_calendar_widget_1"></div>-->
        <!--            &lt;!&ndash;end::Calendar&ndash;&gt;-->
        <!--          </div>-->
        <!--          &lt;!&ndash;end::Card body&ndash;&gt;-->
        <!--        </div>-->
        <!--end::Calendar Widget 1-->
        <!--begin::Modals-->
        <!--begin::Modal - New Product-->
        <div
          class="modal fade"
          id="kt_modal_add_event"
          tabindex="-1"
          aria-hidden="true"
        >
          <!--begin::Modal dialog-->
          <div class="modal-dialog modal-dialog-centered mw-650px">
            <!--begin::Modal content-->
            <div class="modal-content">
              <!--begin::Form-->
              <form class="form" action="#" id="kt_modal_add_event_form">
                <!--begin::Modal header-->
                <div class="modal-header">
                  <!--begin::Modal title-->
                  <h2 class="fw-bolder" data-kt-calendar="title">Add Event</h2>
                  <!--end::Modal title-->
                  <!--begin::Close-->
                  <div
                    class="btn btn-icon btn-sm btn-active-icon-primary"
                    id="kt_modal_add_event_close"
                  >
                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                    <span class="svg-icon svg-icon-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          opacity="0.5"
                          x="6"
                          y="17.3137"
                          width="16"
                          height="2"
                          rx="1"
                          transform="rotate(-45 6 17.3137)"
                          fill="black"
                        />
                        <rect
                          x="7.41422"
                          y="6"
                          width="16"
                          height="2"
                          rx="1"
                          transform="rotate(45 7.41422 6)"
                          fill="black"
                        />
                      </svg>
                    </span>
                    <!--end::Svg Icon-->
                  </div>
                  <!--end::Close-->
                </div>
                <!--end::Modal header-->
                <!--begin::Modal body-->
                <div class="modal-body py-10 px-lg-17">
                  <!--begin::Input group-->
                  <div class="fv-row mb-9">
                    <!--begin::Label-->
                    <label class="fs-6 fw-bold required mb-2">Event Name</label>
                    <!--end::Label-->
                    <!--begin::Input-->
                    <input
                      type="text"
                      class="form-control form-control-solid"
                      placeholder=""
                      name="calendar_event_name"
                    />
                    <!--end::Input-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="fv-row mb-9">
                    <!--begin::Label-->
                    <label class="fs-6 fw-bold mb-2">Event Description</label>
                    <!--end::Label-->
                    <!--begin::Input-->
                    <input
                      type="text"
                      class="form-control form-control-solid"
                      placeholder=""
                      name="calendar_event_description"
                    />
                    <!--end::Input-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="fv-row mb-9">
                    <!--begin::Label-->
                    <label class="fs-6 fw-bold mb-2">Event Location</label>
                    <!--end::Label-->
                    <!--begin::Input-->
                    <input
                      type="text"
                      class="form-control form-control-solid"
                      placeholder=""
                      name="calendar_event_location"
                    />
                    <!--end::Input-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="fv-row mb-9">
                    <!--begin::Checkbox-->
                    <label
                      class="form-check form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="kt_calendar_datepicker_allday"
                      />
                      <span
                        class="form-check-label fw-bold"
                        for="kt_calendar_datepicker_allday"
                        >All Day</span
                      >
                    </label>
                    <!--end::Checkbox-->
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row row-cols-lg-2 g-10">
                    <div class="col">
                      <div class="fv-row mb-9">
                        <!--begin::Label-->
                        <label class="fs-6 fw-bold mb-2 required"
                          >Event Start Date</label
                        >
                        <!--end::Label-->
                        <!--begin::Input-->
                        <input
                          class="form-control form-control-solid"
                          name="calendar_event_start_date"
                          placeholder="Pick a start date"
                          id="kt_calendar_datepicker_start_date"
                        />
                        <!--end::Input-->
                      </div>
                    </div>
                    <div class="col" data-kt-calendar="datepicker">
                      <div class="fv-row mb-9">
                        <!--begin::Label-->
                        <label class="fs-6 fw-bold mb-2"
                          >Event Start Time</label
                        >
                        <!--end::Label-->
                        <!--begin::Input-->
                        <input
                          class="form-control form-control-solid"
                          name="calendar_event_start_time"
                          placeholder="Pick a start time"
                          id="kt_calendar_datepicker_start_time"
                        />
                        <!--end::Input-->
                      </div>
                    </div>
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->
                  <div class="row row-cols-lg-2 g-10">
                    <div class="col">
                      <div class="fv-row mb-9">
                        <!--begin::Label-->
                        <label class="fs-6 fw-bold mb-2 required"
                          >Event End Date</label
                        >
                        <!--end::Label-->
                        <!--begin::Input-->
                        <input
                          class="form-control form-control-solid"
                          name="calendar_event_end_date"
                          placeholder="Pick a end date"
                          id="kt_calendar_datepicker_end_date"
                        />
                        <!--end::Input-->
                      </div>
                    </div>
                    <div class="col" data-kt-calendar="datepicker">
                      <div class="fv-row mb-9">
                        <!--begin::Label-->
                        <label class="fs-6 fw-bold mb-2">Event End Time</label>
                        <!--end::Label-->
                        <!--begin::Input-->
                        <input
                          class="form-control form-control-solid"
                          name="calendar_event_end_time"
                          placeholder="Pick a end time"
                          id="kt_calendar_datepicker_end_time"
                        />
                        <!--end::Input-->
                      </div>
                    </div>
                  </div>
                  <!--end::Input group-->
                </div>
                <!--end::Modal body-->
                <!--begin::Modal footer-->
                <div class="modal-footer flex-center">
                  <!--begin::Button-->
                  <button
                    type="reset"
                    id="kt_modal_add_event_cancel"
                    class="btn btn-light me-3"
                  >
                    Cancel
                  </button>
                  <!--end::Button-->
                  <!--begin::Button-->
                  <button
                    type="button"
                    id="kt_modal_add_event_submit"
                    class="btn btn-primary"
                  >
                    <span class="indicator-label">Submit</span>
                    <span class="indicator-progress"
                      >Please wait...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span
                    ></span>
                  </button>
                  <!--end::Button-->
                </div>
                <!--end::Modal footer-->
              </form>
              <!--end::Form-->
            </div>
          </div>
        </div>
        <!--end::Modal - New Product-->
        <!--begin::Modal - New Product-->
        <div
          class="modal fade"
          id="kt_modal_view_event"
          tabindex="-1"
          aria-hidden="true"
        >
          <!--begin::Modal dialog-->
          <div class="modal-dialog modal-dialog-centered mw-650px">
            <!--begin::Modal content-->
            <div class="modal-content">
              <!--begin::Modal header-->
              <div class="modal-header border-0 justify-content-end">
                <!--begin::Edit-->
                <div
                  class="btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-primary me-2"
                  data-bs-toggle="tooltip"
                  data-bs-dismiss="click"
                  title="Edit Event"
                  id="kt_modal_view_event_edit"
                >
                  <!--begin::Svg Icon | path: icons/duotune/art/art005.svg-->
                  <span class="svg-icon svg-icon-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        opacity="0.3"
                        d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                        fill="black"
                      />
                      <path
                        d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                </div>
                <!--end::Edit-->
                <!--begin::Edit-->
                <div
                  class="btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-danger me-2"
                  data-bs-toggle="tooltip"
                  data-bs-dismiss="click"
                  title="Delete Event"
                  id="kt_modal_view_event_delete"
                >
                  <!--begin::Svg Icon | path: icons/duotune/general/gen027.svg-->
                  <span class="svg-icon svg-icon-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                        fill="black"
                      />
                      <path
                        opacity="0.5"
                        d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                        fill="black"
                      />
                      <path
                        opacity="0.5"
                        d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                </div>
                <!--end::Edit-->
                <!--begin::Close-->
                <div
                  class="btn btn-icon btn-sm btn-color-gray-500 btn-active-icon-primary"
                  data-bs-toggle="tooltip"
                  title="Hide Event"
                  data-bs-dismiss="modal"
                >
                  <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                  <span class="svg-icon svg-icon-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <rect
                        opacity="0.5"
                        x="6"
                        y="17.3137"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(-45 6 17.3137)"
                        fill="black"
                      />
                      <rect
                        x="7.41422"
                        y="6"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(45 7.41422 6)"
                        fill="black"
                      />
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                </div>
                <!--end::Close-->
              </div>
              <!--end::Modal header-->
              <!--begin::Modal body-->
              <div class="modal-body pt-0 pb-20 px-lg-17">
                <!--begin::Row-->
                <div class="d-flex">
                  <!--begin::Icon-->
                  <!--begin::Svg Icon | path: icons/duotune/general/gen014.svg-->
                  <span class="svg-icon svg-icon-1 svg-icon-muted me-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        opacity="0.3"
                        d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z"
                        fill="black"
                      />
                      <path
                        d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z"
                        fill="black"
                      />
                      <path
                        d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                  <!--end::Icon-->
                  <div class="mb-9">
                    <!--begin::Event name-->
                    <div class="d-flex align-items-center mb-2">
                      <span
                        class="fs-3 fw-bolder me-3"
                        data-kt-calendar="event_name"
                      ></span>
                      <span
                        class="badge badge-light-success"
                        data-kt-calendar="all_day"
                      ></span>
                    </div>
                    <!--end::Event name-->
                    <!--begin::Event description-->
                    <div
                      class="fs-6"
                      data-kt-calendar="event_description"
                    ></div>
                    <!--end::Event description-->
                  </div>
                </div>
                <!--end::Row-->
                <!--begin::Row-->
                <div class="d-flex align-items-center mb-2">
                  <!--begin::Icon-->
                  <!--begin::Svg Icon | path: icons/duotune/abstract/abs050.svg-->
                  <span class="svg-icon svg-icon-1 svg-icon-success me-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <circle fill="#000000" cx="12" cy="12" r="8" />
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                  <!--end::Icon-->
                  <!--begin::Event start date/time-->
                  <div class="fs-6">
                    <span class="fw-bolder">Starts</span>
                    <span data-kt-calendar="event_start_date"></span>
                  </div>
                  <!--end::Event start date/time-->
                </div>
                <!--end::Row-->
                <!--begin::Row-->
                <div class="d-flex align-items-center mb-9">
                  <!--begin::Icon-->
                  <!--begin::Svg Icon | path: icons/duotune/abstract/abs050.svg-->
                  <span class="svg-icon svg-icon-1 svg-icon-danger me-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <circle fill="#000000" cx="12" cy="12" r="8" />
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                  <!--end::Icon-->
                  <!--begin::Event end date/time-->
                  <div class="fs-6">
                    <span class="fw-bolder">Ends</span>
                    <span data-kt-calendar="event_end_date"></span>
                  </div>
                  <!--end::Event end date/time-->
                </div>
                <!--end::Row-->
                <!--begin::Row-->
                <div class="d-flex align-items-center">
                  <!--begin::Icon-->
                  <!--begin::Svg Icon | path: icons/duotune/general/gen018.svg-->
                  <span class="svg-icon svg-icon-1 svg-icon-muted me-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        opacity="0.3"
                        d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z"
                        fill="black"
                      />
                      <path
                        d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                  <!--end::Icon-->
                  <!--begin::Event location-->
                  <div class="fs-6" data-kt-calendar="event_location"></div>
                  <!--end::Event location-->
                </div>
                <!--end::Row-->
              </div>
              <!--end::Modal body-->
            </div>
          </div>
        </div>
        <!--end::Modal - New Product-->
        <!--end::Modals-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::Post-->
  </div>
  <!--end::Content-->
</template>

<script>
export default {
  name: "dashboard",
  data() {
    return {
      id: this.$route.params.id,
      languages: this.$dashboardData.allLanguages,
      showLang: this.$dashboardData.languageUniversal,
      form: {},
      loading: 1,
      errors: [],
      postList: [],
      delivered: [],
      monthly: [],
      weekly: [],
      daily: [],
    };
  },

  mounted() {
    this.$i18n.locale = localStorage.getItem("languageUniversal");
    var dir = "";
    if (localStorage.getItem("languageUniversal") == "ar") {
      dir = "rtl";
    } else {
      dir = "ltr";
    }
    let htmlEl = document.querySelector("html");
    htmlEl.setAttribute("dir", dir);
    htmlEl.setAttribute("lang", localStorage.getItem("languageUniversal"));
    this.getResult();
    this.getNew();
    this.getMonthly();
    this.getWeekly();
    this.getDaily();
  },
  methods: {
    getResult() {
      this.$axios.get("admin/dashboard").then((response) => {
        this.form = response.data.data;
        this.loading = 0;
      });
    },
    getNew(page = 1) {
      this.$axios
        .post("admin/order?page=" + page, {
          status: "new",
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.postList = response.data.data.data;
          }
          if (response.data.code == 202) {
            this.postList = [];
          }
        });
    },
    getDelivered(page = 1) {
      this.$axios
        .post("admin/order?page=" + page, {
          status: "delivered",
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.delivered = response.data.data.data;
          }
          if (response.data.code == 202) {
            this.delivered = [];
          }
        });
    },
    getMonthly() {
      this.$axios.get("admin/dashboard/monthly-orders").then((response) => {
        if (response.data.code == 200) {
          this.monthly = response.data.data;
        }
        if (response.data.code == 202) {
          this.monthly = [];
        }
      });
    },
    getWeekly() {
      this.$axios.get("admin/dashboard/weekly-orders").then((response) => {
        if (response.data.code == 200) {
          this.weekly = response.data.data;
        }
        if (response.data.code == 202) {
          this.weekly = [];
        }
      });
    },
    getDaily() {
      this.$axios.get("admin/dashboard/daily-orders").then((response) => {
        if (response.data.code == 200) {
          this.daily = response.data.data;
        }
        if (response.data.code == 202) {
          this.daily = [];
        }
      });
    },
  },
};
</script>

<style scoped></style>
